<template>
  <div class="ce-campaign-code-description">
    <div class="content-wrapper">
      <div class="campaign-code-wrapper">
        <div class="campaign-code-container">
          <div class="campaign-code-background">
            <img :src="objectdata.backgroundimage" />
          </div>
          <div class="campaign-code-text">
            <div
              v-html="getHeadline(objectdata.headline.unit, objectdata.headline.value, objectdata.headlinecentered)"
            />
            <div v-bind:inner-html.prop="objectdata.text | replaceNbsp | replaceAmp" />
          </div>
          <div class="campaign-code-image animated delay-1s">
            <img :src="objectdata.packshotimage" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Base from "./Base.vue";
export default {
  extends: Base,
  props: {
    type: false,
    objectdata: {}
  },

  data() {
    return {};
  },
  created() {
    // this.init();
  },
  mounted() {
    this.initAnimation();
  },
  methods: {
    initAnimation() {
      let objThis = this;
      // 	// animate packshot
      let elemCode = document.querySelector(".campaign-code-image");
      // 	let animationNameCode = "fadeInRightBig";
      // 	setTimeout(function() {
      // 		elemCode.classList.add(animationNameCode);
      // 	}, 800);
      window.onscroll = function() {
        if (objThis.inViewport(elemCode)) {
          elemCode.classList.add("fadeIn");
        }
      };
      // window.addEventListener("scroll", function() {
      // 	console.log("scroll");
      // 	if (objThis.inViewport(elemCode)) {
      // 		elemCode.classList.add("fadeInLeft");
      // 	}
      // });
    }
  },
  composed: {
    getfullheadline() {
      return;
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/variables.scss";
@import "@/scss/mixins.scss";

.ce-campaign-code-description {
  // padding: 0 20px;
  .campaign-code-wrapper {
    margin: 0 auto;
    position: relative;
    max-width: 750px;
    .campaign-code-container {
      position: relative;
      margin-bottom: 130px;
      @include min-screen($screen-min-m) {
        margin-bottom: 0;
      }
    }
    .campaign-code-background {
      margin: 0 -30px;
      @include min-screen($screen-min-xs) {
        margin: 0;
      }
      @include min-screen($screen-min-s) {
        max-width: 460px;
        margin: 0 auto;
      }
      @include min-screen($screen-min-m) {
        max-width: 520px;
        margin: 0 0 0 auto;
      }
    }
    .campaign-code-text {
      text-align: center;
      position: absolute;
      top: 50%;
      padding: 10px;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 80%;

      display: flex;
      flex-direction: column;
      justify-content: center;
      @include min-screen($screen-min-s) {
        margin: 0 auto;
        height: 100%;
        box-sizing: border-box;
        padding: 40px 50px;
        width: 100%;
        max-width: 460px;
      }
      @include min-screen($screen-min-m) {
        max-width: 480px;
        right: 0;
        // padding: 40px 60px 40px 40px;
        padding: 40px 80px 40px 70px;
        left: auto;
        transform: translate(0, -50%);
      }

      h1,
      h2,
      h3 {
        margin-bottom: 10px;
        @include min-screen($screen-min-xs) {
          margin-bottom: 20px;
        }
      }
      p {
        margin: 0;
      }
    }
    .campaign-code-image {
      opacity: 0;
      max-width: 180px;
      margin-top: -54px;
      margin-left: 38px;
      z-index: 3;
      position: absolute;
      @include min-screen($screen-min-xs) {
        // max-width: 190px;
        // margin-top: -65px;
      }
      @include min-screen($screen-min-s) {
        max-width: 190px;
        margin-top: -95px;
        left: 50%;
        transform: translateX(-120%);
      }
      @include min-screen($screen-min-m) {
        max-width: 250px;
        margin: 0 0 0 -120px;
        transform: translateX(-70%);
        position: absolute;
        top: 30px;
        img {
          max-width: 215px;

          @include min-screen($screen-min-m) {
            max-width: 250px;
          }
        }
      }
    }
  }
}
</style>